import { useMemo } from 'react';
import { useBasketProductState } from './useBasketProductState';

type BackorderData = {
    isOnlyBackOrder: boolean;
    selectedQuantityInStock: number;
    selectedQuantityInBackorder: number;
    includesItemsInBackorder: boolean;
};

type UseBackorderProductItemData = (productId: string, quantity: number) => BackorderData;

export const useBackorderProductItemData: UseBackorderProductItemData = (
    productId: string,
    quantity: number,
): BackorderData => {
    const { getFlagsForProduct, getStateForProduct } = useBasketProductState();

    return useMemo(() => {
        const productFlags = getFlagsForProduct(productId, quantity);
        const productState = getStateForProduct(productId);

        const { includesItemsInBackorder, isOnlyBackOrder } = productFlags ?? {
            includesItemsInBackorder: false,
            isOnlyBackOrder: false,
        };

        const { availability: { allocatedStock = 0 } = {} } = productState ?? {
            availability: {
                allocatedStock: 0,
                backorderInStockDate: 0,
            },
        };

        return {
            isOnlyBackOrder,
            selectedQuantityInStock: allocatedStock,
            selectedQuantityInBackorder: quantity - allocatedStock,
            includesItemsInBackorder,
        };
    }, [getFlagsForProduct, getStateForProduct, productId, quantity]);
};
